import { create } from 'zustand';

type HoverStoreState = {
  hoveredPropertyId?: string;
};

type HoverStoreActions = {
  setHoveredPropertyId: (propertyId?: string) => void;
};

export const useHoverStore = create<HoverStoreState & HoverStoreActions>((set) => ({
  hoveredPropertyId: undefined,
  setHoveredPropertyId: (propertyId) => set({ hoveredPropertyId: propertyId }),
}));
